import { analyticsEventsTracker, EVENT_TRACKERS, GTMOnboardingFunnelEvent } from '../analytics';
import { getParameterFromURL } from './getParameterFromUrl';

/**
 * Универсальная функция для AB-теста с 2 или 3 вариантами.
 *
 * @param {number} count — количество вариантов (2 или 3)
 * @param {string} key — ключ в localStorage и имя события для трекинга
 * @param {...*} args — значения и вероятности:
 *    Для 2 вариантов: valueA, valueB, probabilityA, probabilityB
 *    Для 3 вариантов: valueA, valueB, valueC, probabilityA, probabilityB, probabilityC
 * @returns {*} — выбранное (или ранее сохранённое) значение
 */
function saveABTestValue(count, key, ...args) {
  const stored = localStorage.getItem(key);

  function hasKeyInDataLayer(key) {
    var dl = window.dataLayer;
    if (!Array.isArray(dl)) return false;

    return dl.some(function (item) {
      if (!item || typeof item !== 'object') return false;
      return Object.values(item).some(function (v) {
        return v === key;
      });
    });
  }

  if (stored !== null) {
    // ✅ если key уже встречался в dataLayer — повторно не трекаем
    if (!hasKeyInDataLayer(key)) {
      analyticsEventsTracker.trackWithTarget(GTMOnboardingFunnelEvent.abTest(key, stored), EVENT_TRACKERS.GTM);

      // ✅ (опционально) помечаем, чтобы следующие вызовы точно не трекали
      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push({ abTestKey: key });
    }

    return key + '_' + stored;
  }

  let values, probabilities;

  if (count === 2) {
    // args: valueA, valueB, probabilityA, probabilityB
    values = args.slice(0, 2);
    probabilities = args.slice(2, 4);
  } else if (count === 3) {
    // args: valueA, valueB, valueC, probabilityA, probabilityB, probabilityC
    values = args.slice(0, 3);
    probabilities = args.slice(3, 6);
  } else {
    throw new Error('Поддерживается только 2 или 3 варианта');
  }

  // === Новый блок: переопределение значений из URL-параметров ===
  const overrideA = getParameterFromURL('AValue');
  const overrideB = getParameterFromURL('BValue');
  const overrideC = count === 3 ? getParameterFromURL('CValue') : null;

  if (window.location.hostname !== 'webapp.everydoggy.com') {
    if (overrideA != null) probabilities[0] = Number(overrideA);
    if (overrideB != null) probabilities[1] = Number(overrideB);
    if (count === 3 && overrideC != null) probabilities[2] = Number(overrideC);
  }

  // === /Новый блок ===
  const total = probabilities.reduce((sum, p) => sum + p, 0);
  if (Math.abs(total - 100) > 0.01) {
    if (count === 2) {
      probabilities[0] = 50;
      probabilities[1] = 50;
    }
    if (count === 3) {
      probabilities[0] = 40;
      probabilities[1] = 30;
      probabilities[2] = 30;
    }
  }

  const r = Math.random() * 100;
  let cumulative = 0;
  let result;

  for (let i = 0; i < probabilities.length; i++) {
    cumulative += probabilities[i];
    if (r < cumulative) {
      result = values[i];
      break;
    }
  }

  analyticsEventsTracker.trackWithTarget(GTMOnboardingFunnelEvent.abTest(key, result), EVENT_TRACKERS.GTM);

  localStorage.setItem(key, result);

  return `${key}_${result}`;
}

export default saveABTestValue;
